import { useCallback } from 'react';
import { useMutation } from '@apollo/client';

import {
  ConnectSnappyMutation,
  ConnectSnappyMutationVariables,
  DisconnectSnappyMutation,
  DisconnectSnappyMutationVariables
} from 'graphql.types';
import {
  connectSnappy,
  disconnectSnappy
} from 'settings/graphql/configureSnappy';

export function useSnappy() {
  const [connectSnappyMutation] = useMutation<
    ConnectSnappyMutation,
    ConnectSnappyMutationVariables
  >(connectSnappy, { refetchQueries: ['getSnappyCampaigns'] });
  const [disconnectSnappyMutation] = useMutation<
    DisconnectSnappyMutation,
    DisconnectSnappyMutationVariables
  >(disconnectSnappy);

  const connect = useCallback(
    (apiKey: string) =>
      connectSnappyMutation({ variables: { apiKey } }).then(
        ({ data }) => data?.setSnappyApiKey.enabled || false
      ),
    [connectSnappyMutation]
  );

  const disconnect = useCallback(
    () =>
      disconnectSnappyMutation().then(
        ({ data }) => data?.disconnectSnappyIntegration.enabled || false
      ),
    [disconnectSnappyMutation]
  );

  return { connect, disconnect };
}
